import { NgModule } from '@angular/core';

import { testTranslateService as noticeTranslateService } from '@plugins/client/notice';
import {
  ConfigureTranslateModule,
  KeyAndLoader,
  registerLibTranslation,
} from '@plugins/client/translate/loaders';
import {
  mergeTranslateTargetsToSource,
  prepareTestTranslateService,
  TranslateService,
} from '@plugins/client/translate/services';

export const TRANSLATION_KEY = 'featureCheck';
export const loader = (lang: string) => import(`./assets/i18n/${lang}.json`);

const source: KeyAndLoader = {
  loader,
  key: TRANSLATION_KEY,
};

export const loadTranslations = registerLibTranslation(source);

@NgModule()
@loadTranslations
export class FeatureCheckTranslationModule extends ConfigureTranslateModule.configureLib(
  source,
) {}

export const testTranslateService = async () => {
  return await mergeTranslateTargetsToSource(
    prepareTestTranslateService({
      key: TRANSLATION_KEY,
      loaders: loader,
    }),
    noticeTranslateService(),
  );
};

export const translateProvider = async () => {
  return {
    provide: TranslateService,
    useValue: await testTranslateService(),
  };
};
